import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
// 引入ant-design-vue
// import Antd from 'ant-design-vue';
import * as Icons from '@ant-design/icons-vue'
import 'ant-design-vue/dist/antd.css';
import { message ,
  Button,ConfigProvider,Breadcrumb,Card,Menu,Dropdown,Modal,Form,Select,Input,Upload,Radio,Table,Pagination,Tabs, Switch, Checkbox,
  Space,
  Row,
  Col,
  Cascader,
  InputNumber,
  Empty,
  Spin,
  DatePicker
} from "ant-design-vue";

message.config({
  duration: 5,
});
// 引入Excel表格样式
import 'handsontable/dist/handsontable.full.css';
// 标签初始化样式
import './assets/css/base.css'
// 公用样式
import './assets/css/comment.css'

const icons: any = Icons;

const app = createApp(App);
// 全局注入提示
app.config.globalProperties.$message = message
for (const i in icons) {
  app.component(i, icons[i]);
}

// 全局引入表格组件
import TableList from "./components/TableList/index.vue";
app.component('TableList',TableList)
// 全局引入提示组件
import Tooltip from "./components/tooltip/index.vue";
app.component('Tooltip',Tooltip)
// 引入svg
import SvgIcon from "./components/svg/index.vue";
app.component('SvgIcon',SvgIcon)

app.use(store)
.use(router)
// .use(Antd)
.use(Button)
.use(ConfigProvider)
.use(Breadcrumb)
.use(Card)
.use(Menu)
.use(Dropdown)
.use(Modal)

.use(Form)
.use(Select)
.use(Input)
.use(Upload)
.use(Radio)
.use(Table)
.use(Pagination)
.use(Tabs)
.use(Switch)
.use(Checkbox)
.use(Cascader)
.use(Space)
.use(Row)
.use(Col)
.use(InputNumber)
.use(Empty)
.use(Spin).use(DatePicker)
.mount('#app')
